import React from 'react';
import { Card } from '@/components/ui/card';
import { Users } from 'lucide-react';
import { getSubjectColor } from './subjectColor';

export const DepartmentGridView = ({
  days,
  periods,
  selectedSubject,
  departmentData,
}) => (
  <Card className="p-4 sm:p-6" data-testid="department-view">
    {!selectedSubject?.trim() ? (
      <div className="text-center py-12">
        <Users className="mx-auto h-12 w-12 text-slate-300 mb-4" />
        <p className="text-slate-600 font-medium mb-1">Select a subject to view the department</p>
        <p className="text-sm text-slate-400">Use the "Select subject" dropdown above</p>
      </div>
    ) : (
      <>
        <div className="flex items-center justify-between mb-5">
          <div>
            <h2 className="text-xl font-bold text-slate-900">{selectedSubject} Department</h2>
            <p className="text-sm text-slate-500">{departmentData.length} teacher{departmentData.length !== 1 ? 's' : ''} teaching this subject</p>
          </div>
        </div>
        <div className="space-y-4">
          {departmentData.map(teacher => {
            const lookup = {};
            teacher.entries.forEach(e => { lookup[`${e.day}-${e.period}`] = e; });
            return (
              <div key={teacher.id} className="border border-slate-200 rounded-lg overflow-hidden" data-testid={`dept-teacher-${teacher.id}`}>
                <div className="bg-slate-50 px-4 py-2.5 flex items-center justify-between border-b border-slate-200">
                  <span className="font-semibold text-sm text-slate-900">{teacher.name}</span>
                  <span className="text-xs text-slate-500">{teacher.entries.length} lessons/week</span>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-xs border-collapse">
                    <thead>
                      <tr>
                        <th className="p-1.5 text-left text-[10px] font-medium text-slate-400 w-14"></th>
                        {days.map(d => <th key={d} className="p-1.5 text-center text-[10px] font-medium text-slate-500" style={{ minWidth: '100px' }}>{d.slice(0, 3)}</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {periods.map((period, pIdx) => (
                        <tr key={period}>
                          <td className="p-1 text-[10px] text-slate-400 whitespace-nowrap">P{pIdx + 1}</td>
                          {days.map(day => {
                            const entry = lookup[`${day}-${period}`];
                            return (
                              <td key={day} className="p-0.5" style={{ minWidth: '100px' }}>
                                {entry ? (
                                  <div className={`px-2 py-1 rounded text-[10px] border ${getSubjectColor(entry.subject)}`}>
                                    <span className="font-semibold">{entry.class_name}</span>
                                  </div>
                                ) : (
                                  <div className="px-2 py-1 text-center text-slate-200 text-[10px]">-</div>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      </>
    )}
  </Card>
);
